import {h, Component} from 'preact';
import {Field} from 'formik';
import invoke from 'lodash.invoke';
import cx from 'classnames';
import {Label, InputFeedback, Hint} from '../index';

export class SelectField extends Component {

    componentDidMount () {
        if ( this.props.isFocused ) {
            setTimeout( () => this.field && this.field.focus(), 10 )
        }
    }

    componentDidUpdate () {
        if ( this.props.isFocused ) {
            this.field && this.field.focus();
        }
    }

    onChange = e => invoke( this.props, 'onChange', e );

    render ( {id, name, label, hint, error, errorShown, value, onChange, onBlur, className, children, ...props} ) {

        const groupClasses = cx(
            'select-group',
            className,
            {
                'animated shake error': !!error || !!errorShown
            }
        );

        const inputClasses = cx(
            'input-select w-full',
            {'disabled': props.disabled}
        );

        return (
            <div className={groupClasses}>
                {label &&
                <Label htmlFor={id} error={error}>
                    {label}
                </Label>
                }
                {hint &&
                <Hint htmlFor={id} error={error}>
                    {hint}
                </Hint>
                }
                <Field
                    component="select"
                    innerRef={ref => this.field = ref}
                    id={id}
                    name={name || id}
                    className={inputClasses}
                    onBlur={onBlur}
                    onChange={this.onChange}
                    value={value}
                    {...props}>
                    {children}
                </Field>
                <InputFeedback error={error}/>
            </div>
        );
    };
}
